
import React, { useMemo } from 'react';
import { Activity, Heart, Sun, Smile, Droplets } from 'lucide-react';
import VitalScoreMetricCircle from './VitalScoreMetricCircle';

interface VitalScoreGridProps {
  vitalScore: {
    energyRest: { score: number; energyScore?: number; restScore?: number };
    nutrition: { score: number };
    movement: { score: number };
    hydrationSun: { waterScore: number; sunScore: number };
  };
}

const VitalScoreGrid: React.FC<VitalScoreGridProps> = React.memo(({ vitalScore }) => {
  // Memoizar los scores para evitar recálculos
  const scores = useMemo(() => {
    const energyRestScore = vitalScore?.energyRest?.score ?? 0;
    const nutritionScore = vitalScore?.nutrition?.score ?? 0;
    const movementScore = vitalScore?.movement?.score ?? 0;
    const waterScore = vitalScore?.hydrationSun?.waterScore ?? 0;
    const sunScore = vitalScore?.hydrationSun?.sunScore ?? 0;

    console.log('VitalScoreGrid rendering with scores:', {
      energyRestScore,
      nutritionScore,
      movementScore,
      waterScore,
      sunScore
    });

    return {
      energyRestScore,
      nutritionScore,
      movementScore,
      waterScore,
      sunScore
    };
  }, [vitalScore]);

  return (
    <div className="grid grid-cols-3 gap-2 mb-2 md:grid-cols-5 md:gap-2 md:mb-0">
      <VitalScoreMetricCircle
        score={scores.energyRestScore}
        label="Energía/Descanso"
        icon={<Smile className="h-4 w-4 text-amber-500" />}
        className="bg-gradient-to-br from-amber-500/5 to-amber-600/10 border-amber-100/20"
      />

      <VitalScoreMetricCircle
        score={scores.nutritionScore}
        label="Nutrición"
        icon={<Heart className="h-4 w-4 text-rose-500" />}
        className="bg-gradient-to-br from-rose-500/5 to-rose-600/10 border-rose-100/20"
      />

      <VitalScoreMetricCircle
        score={scores.movementScore}
        label="Movimiento"
        icon={<Activity className="h-4 w-4 text-blue-500" />}
        className="bg-gradient-to-br from-blue-500/5 to-blue-600/10 border-blue-100/20"
      />

      <VitalScoreMetricCircle
        score={scores.waterScore}
        label="Hidratación"
        icon={<Droplets className="h-4 w-4 text-teal-500" />}
        className="col-start-1 col-end-2 md:col-auto bg-gradient-to-br from-teal-500/5 to-teal-600/10 border-teal-100/20"
      />

      <VitalScoreMetricCircle
        score={scores.sunScore}
        label="Sol"
        icon={<Sun className="h-4 w-4 text-yellow-500" />}
        className="col-start-2 col-end-3 md:col-auto bg-gradient-to-br from-yellow-500/5 to-yellow-600/10 border-yellow-100/20"
      />
    </div>
  );
});

VitalScoreGrid.displayName = 'VitalScoreGrid';

export default VitalScoreGrid;
